import React, {useCallback, useMemo} from 'react';
import {Text} from 'react-native';
import {TruItem} from '../../../../shared/models/api/eCertificatesResponsePayload';
import {Table} from '../../../../shared/components/table';
import {Column} from '../../../../shared/components/table/model';
import {useTruTableStyles} from './TruTable.style';
import {numberFormatToRub} from '../../../../shared/utils/numberFormatToRub';

interface TruTableProps {
  tru?: TruItem[];
  certificateType?: string;
  activeTruIds?: number[];
  onTruClick: (truId: number) => void;
}

export function TruTable({tru, certificateType, activeTruIds, onTruClick}: TruTableProps) {
  const styles = useTruTableStyles();

  const columns: Column<TruItem>[] = useMemo(() => {
    const cols = [
      {
        title: '',
        field: 'truName',
        render: (row: TruItem) => (
          <Text style={activeTruIds?.includes(row.truId) ? styles.colTextSecondary : styles.colText}>
            {row.truName}
          </Text>
        ),
        headStyles: {
          colHeadStyle: {flexBasis: certificateType === 'ECTP0002' ? '100%' : '50%'},
        },
        styles: {
          colBodyStyle: {flexBasis: certificateType === 'ECTP0002' ? '100%' : '50%'},
        },
      },
    ];

    if (certificateType === 'ECTP0001') {
      cols.push({
        title: 'Предельное кол-во',
        field: 'maxQuantity',
        render: (row: TruItem) => {
          return <Text style={styles.colText}>{row.maxQuantity ? `${row.maxQuantity} шт` : '–'}</Text>;
        },
        headStyles: {
          colHeadStyle: {flexBasis: '25%'},
        },
        styles: {
          colBodyStyle: {flexBasis: '25%'},
        },
      });
      cols.push({
        title: 'Предельная стоимость',
        field: 'maxAmount',
        render: (row: TruItem) => {
          return <Text style={styles.colText}>{numberFormatToRub(row.maxAmount) ?? '–'}</Text>;
        },
        headStyles: {
          colHeadStyle: {flexBasis: '25%'},
        },
        styles: {
          colBodyStyle: {flexBasis: '25%'},
        },
      });
      return cols;
    }
    if (certificateType === 'ECTP0003') {
      cols.push({
        title: 'Предельная стоимость',
        field: 'maxAmount',
        render: (row: TruItem) => {
          return <Text style={styles.colText}>{numberFormatToRub(row.maxAmount) ?? '–'}</Text>;
        },
        headStyles: {
          colHeadStyle: {flexBasis: '50%'},
        },
        styles: {
          colBodyStyle: {flexBasis: '50%'},
        },
      });
      return cols;
    }
    if (certificateType === 'ECTP0004') {
      cols.push({
        title: 'Предельное кол-во',
        field: 'maxQuantity',
        render: (row: TruItem) => {
          return <Text style={styles.colText}>{row.maxQuantity ? `${row.maxQuantity} шт` : '–'}</Text>;
        },
        headStyles: {
          colHeadStyle: {flexBasis: '50%'},
        },
        styles: {
          colBodyStyle: {flexBasis: '50%'},
        },
      });
      return cols;
    }
    return cols;
  }, [activeTruIds, certificateType]);

  const handleRowClick = useCallback(
    (row: TruItem) => {
      onTruClick(row.truId);
    },
    [onTruClick],
  );

  return (
    <Table
      data={tru}
      columns={columns}
      // onRowClick={handleRowClick}
    />
  );
}
